import React, { type PropsWithChildren } from "react";
import { Modal, ConfigProvider } from "antd";
import { CloseOutlined } from "@ant-design/icons";
import { createPrimaryTheme } from "../../theme/antd-theme";

interface CenterModalProps {
  open: boolean;
  onClose: () => void;
  title?: string;
  width?: number;
  footer?: React.ReactNode;
  centered?: boolean;
  closable?: boolean;
  maskClosable?: boolean;
  className?: string;
}

const CenterModal: React.FC<PropsWithChildren<CenterModalProps>> = ({
  children,
  open,
  onClose,
  title,
  width = 520,
  footer = null,
  centered = true,
  closable = true,
  maskClosable = true,
  className,
}) => {
  return (
    <ConfigProvider theme={createPrimaryTheme()}>
      <Modal
        open={open}
        onCancel={onClose}
        title={title}
        width={width}
        footer={footer}
        centered={centered}
        closable={closable}
        maskClosable={maskClosable}
        className={className}
        closeIcon={<CloseOutlined />}
        destroyOnClose
      >
        {children}
      </Modal>
    </ConfigProvider>
  );
};

export default CenterModal;

